// A risk in assessment has one record per person: the admin's placeholder
// (created when the risk enters assessment) plus one per person who scores it.
// Listing every record shows each risk several times, so the assessment pages
// collapse them to one row per risk: the viewer's own record (blank if they
// have not scored it yet) plus team averages across every scored record.

const PERSONAL_FIELDS = [
  "likeLihoodValue",
  "likeLihoodValueScore",
  "likeLihoodComment",
  "riskConsequenceValue",
  "riskConsequenceValueScore",
  "riskConsequenceComment",
  "controlEffectiveness",
  "controlEffectivenessScore",
];

function average(records, field) {
  const scores = records.map((r) => Number(r[field])).filter((v) => v > 0);
  if (scores.length === 0) return 0;
  const avg = scores.reduce((sum, v) => sum + v, 0) / scores.length;
  return Math.round(avg * 10) / 10;
}

function blankRecord(record) {
  const blank = { ...record, inherentRiskScore: 0, residualRiskScore: 0 };
  PERSONAL_FIELDS.forEach((field) => {
    blank[field] = null;
  });
  return blank;
}

export function collapseAssessmentsByRisk(assessments, userId) {
  const byRisk = new Map();
  (assessments || []).forEach((assessment) => {
    const records = byRisk.get(assessment.riskRegisterId) || [];
    records.push(assessment);
    byRisk.set(assessment.riskRegisterId, records);
  });

  return Array.from(byRisk.values()).map((records) => {
    const own = records.find((r) => r.userId === userId);
    return {
      ...(own || blankRecord(records[0])),
      likeLihoodValueScoreAverage: average(records, "likeLihoodValueScore"),
      riskConsequenceValueScoreAverage: average(records, "riskConsequenceValueScore"),
      controlEffectivenessScoreAverage: average(records, "controlEffectivenessScore"),
    };
  });
}
